module.exports = __webpack_public_path__ + "static/media/ic_eye.2e345d45.svg";